const getters = {
  sidebar: state => state.app.sidebar,
  user: state => state.user.userInfo,
  hasLogin:state => state.user.hasLogin
}
  export default getters